import { axiosInstance } from "../../../helper"
import { worship } from "../types"

export function getWorship(params, config) {
	return {
		type: worship.GET_WORSHIP,
		payload: new axiosInstance.get("/admin/schedule-worship", {
			...config,
			params,
		}),
	}
}

export default getWorship
